import gql from "graphql-tag";

const GET_SELECTED_COMMUNITY = gql`
  query {
    selectedCommunityIds @client {
      ids
    }
  }
`;

export default GET_SELECTED_COMMUNITY;
